import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

export const getTransactionsFilters = ({ isLive, origin }: { isLive: boolean, origin?: string }) => {
  const params = { is_live: isLive, ...(origin ? { origin: origin } : {}) };

  return axiosPrivate.get(`/dashboard/v1/transaction/filters`, { params: params });
};